export default "__VITE_ASSET__DjyYOzHD__"